export default __webpack_public_path__ + "static/media/triangle.95d3a905.svg";